import script from "./Year2024OfferBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./Year2024OfferBanner.vue?vue&type=script&setup=true&lang=js"

import "./Year2024OfferBanner.vue?vue&type=style&index=0&id=4611eed7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4611eed7"]])

export default __exports__